export default __webpack_public_path__ + "static/media/MSExcel_Security_2.75344a43.png";